import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Logo from "@/components/base/Logo";

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-stone-100 border-t border-stone-200 pt-14 pb-6">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Main Grid */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-10">
          {/* Brand */}
          <div className="col-span-1">
            <Link to="/" className="inline-block mb-4 cursor-pointer">
              <Logo variant="dark" size="md" />
            </Link>
            <p className="text-sm text-gray-500 leading-relaxed">{t("footer.desc")}</p>
            <div className="flex gap-3 mt-4">
              {["ri-facebook-line", "ri-instagram-line", "ri-linkedin-line"].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className="w-8 h-8 flex items-center justify-center rounded-full bg-stone-200 text-gray-600 hover:bg-red-600 hover:text-white cursor-pointer transition-all"
                >
                  <i className={icon} />
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-xs font-bold text-gray-400 tracking-widest mb-4">
              <a href="#services">{t("footer.services")}</a>
            </h4>
            <ul className="space-y-2">
              {[t("footer.email_hosting"), t("footer.domain"), t("footer.ssl")].map((item) => (
                <li key={item}>
                  <a href="#" rel="nofollow" className="text-sm text-gray-600 hover:text-red-600 cursor-pointer transition-colors">
                    {item}
                  </a>
                </li>
              ))}
              <li>
                <Link to="/pricing" className="text-sm text-gray-600 hover:text-red-600 cursor-pointer transition-colors">
                  {t("nav.pricing")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-xs font-bold text-gray-400 tracking-widest mb-4">
              <a href="#support">{t("footer.help")}</a>
            </h4>
            <ul className="space-y-2">
              {[
                { label: t("footer.faq"), to: "/support" },
                { label: t("footer.contact"), to: "/support" },
                { label: t("footer.docs"), to: "#" },
              ].map((item) => (
                <li key={item.label}>
                  <Link to={item.to} className="text-sm text-gray-600 hover:text-red-600 cursor-pointer transition-colors">
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-xs font-bold text-gray-400 tracking-widest mb-4">
              <a href="#legal">{t("footer.legal")}</a>
            </h4>
            <ul className="space-y-2">
              {[t("footer.terms"), t("footer.privacy"), t("footer.gdpr")].map((item) => (
                <li key={item}>
                  <a href="#" rel="nofollow" className="text-sm text-gray-600 hover:text-red-600 cursor-pointer transition-colors">
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-stone-200 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-gray-400">{t("footer.copyright")}</p>

          <div className="flex items-center gap-1 text-xs text-gray-400">
            <i className="ri-shield-check-line text-green-500" />
            <span>SSL Secured</span>
            <span className="mx-2">|</span>
            <i className="ri-flag-line text-red-500 mr-1" />
            <span>Made in Azerbaijan</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
